import React, { useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import apiService from "../services/ApiService";
import * as Yup from "yup";
import TailwindInput from "./Tailwind/TailwindInput";
import TailwindButton from "./Tailwind/TailwindButton";
import { cn } from "../lib/utils";

const LoginForm = ({ login_succeeds, login_to_validation, report_forgotten_password }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [submitError, setSubmitError] = useState({
    message: '',
    variant: ''
  });

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Provide a valid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      setSubmitError({ message: '', variant: '' });
      setTimeout(() => {
        apiService.classicLogin(values.email, values.password).then(
          async (response) => {
            if (response) {
              if (response.is_active)
                login_succeeds();
              else
                login_to_validation();
            } else {
              setSubmitError({
                message: 'Login failed',
                variant: 'error'
              });
              formik.setSubmitting(false);
            }
          }
        );
      }, 500);
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4">
          <TailwindInput
            fullWidth
            autoComplete="username"
            type="email"
            label="Email Address"
            placeholder="you@example.com"
            {...getFieldProps("email")}
            error={touched.email && errors.email ? String(errors.email) : undefined}
          />

          <div className="relative">
            <TailwindInput
              fullWidth
              autoComplete="current-password"
              type={showPassword ? "text" : "password"}
              label="Password"
              placeholder="Enter your password"
              {...getFieldProps("password")}
              error={touched.password && errors.password ? String(errors.password) : undefined}
            />
            <button
              type="button"
              className="absolute right-3 top-9 text-slate-400 hover:text-slate-600 transition-colors"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <span className="material-symbols-outlined text-[20px]">
                {showPassword ? 'visibility' : 'visibility_off'}
              </span>
            </button>
          </div>

          <div className="flex justify-center mt-1">
            <button
              type="button"
              className="text-sm text-slate-500 hover:text-slate-700 underline underline-offset-2 transition-colors"
              onClick={report_forgotten_password}
            >
              Forgot your password?
            </button>
          </div>

          {submitError.message && (
            <div className={cn(
              "flex items-center gap-2 p-3 rounded-lg text-sm",
              submitError.variant === 'error'
                ? "bg-red-50 text-red-800 border border-red-200"
                : "bg-green-50 text-green-800 border border-green-200"
            )}>
              <span className="material-symbols-outlined text-[18px] shrink-0">error</span>
              {submitError.message}
            </div>
          )}

          <TailwindButton
            fullWidth
            size="lg"
            type="submit"
            variant="dark"
            icon="login"
            disabled={isSubmitting}
            className="mt-2"
          >
            {isSubmitting ? 'Signing in...' : 'Sign in'}
          </TailwindButton>
        </div>
      </Form>
    </FormikProvider>
  );
};

export default LoginForm;
